import { render, staticRenderFns } from "./SalesPointEdit.vue?vue&type=template&id=f38e3202&"
import script from "./SalesPointEdit.vue?vue&type=script&lang=js&"
export * from "./SalesPointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports